export default (val, min, max) => ((val - min) / (max - min)) || 0;